import script from "./indexdom.vue?vue&type=script&setup=true&lang=js"
export * from "./indexdom.vue?vue&type=script&setup=true&lang=js"

import "./indexdom.vue?vue&type=style&index=0&id=1afcaa36&scoped=true&lang=css"

import exportComponent from "E:\\李小东项目管理\\23-5\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1afcaa36"]])

export default __exports__